import type { VisitorSummary } from '@livechat/shared';

import { currentAccessToken, onAccessTokenChanged, refreshSession } from './api.js';
import type { startCobrowseViewer } from './cobrowse-viewer.js';

declare global {
	interface Window {
		startManorsoftCobrowse?: typeof startCobrowseViewer;
	}
}

export function openCobrowseWindow(tenantId: string, visitor: VisitorSummary): void {
	const viewer = window.open(new URL('/cobrowse.html', window.location.origin).href, '_blank');
	if (!viewer) throw new Error('Allow pop-ups for Manorsoft Livechat to use Cobrowse');
	// No popup/size features: prefer a normal tab (the browser's preference has final say).
	// Keep the same-origin bootstrap; never put authentication credentials in the URL.
	const ready = (event: MessageEvent): void => {
		if (
			event.source !== viewer ||
			event.origin !== window.location.origin ||
			event.data !== 'manorsoft:cobrowse:ready'
		)
			return;
		window.removeEventListener('message', ready);
		window.clearTimeout(timeout);
		viewer.startManorsoftCobrowse?.(tenantId, visitor, {
			currentAccessToken,
			onAccessTokenChanged,
			refreshSession,
		});
	};
	window.addEventListener('message', ready);
	const timeout = window.setTimeout(() => window.removeEventListener('message', ready), 30_000);
}
